module.exports = __webpack_public_path__ + "static/facebook_messenger-4f190b5dd6f007d1282d4b3899ec3296.png";